export const PROFILE_DATA = {
  PERSONAL_DATA_EDITABLE_FIELDS: [
    'phone',
    'mobile',
    'curp',
    'nationality_id',
    'relationship_id',
    'employment_status_id',
    'marital_status_id',
    'gender_id',
    'birth_at',
    'has_passed_away',
    'education_level_id',
    'wedding_anniversary_at',
  ],
  ADDRESS_DATA_EDITABLE_FIELDS: [
    'street',
    'neighborhood',
    'int_no',
    'ext_no',
    'city',
    'municipality',
    'zip_code',
    'state_id',
    'country_id',
  ],
  FAMILY_DATA_EDITABLE_FIELDS: [
    'family_email',
    'rcsa_anniversary_at',
    'family_situation_id',
    'family_mobile',
    'family_phone',
  ],
};
